export default function toMeaningfulFixed(number: number, digits = 0, compact = true) {
    const [_, fraction = ''] = number.toString().split('.');

    let precision = digits;
    loop: for (let i = 0; i < fraction.length; i++) {
        const char = fraction[i];
        switch (char) {
            case '1':
            case '2':
            case '3':
            case '4':
                precision = Math.max(i + 1, precision);
                break loop;

            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                precision = Math.max(i, precision);
                break loop;
            default:
                continue loop;
        }
    }

    const output = number.toFixed(precision);

    return compact ? Number(output).toString() : output;
}
